import type { SurveyAnswers, SurveyOtherText, SurveyPrompt } from '../types/api';
import { fetchWithTimeout } from './http';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

/**
 * The questions to ask this person, or `show: false`.
 *
 * The backend answers `show: false` for everything that means "do not ask": the survey
 * is off on this deployment, this person is a DHI colleague rather than a customer, or
 * they have already answered. So the caller never has to know why, only whether.
 */
export async function fetchSurvey(product: string | null): Promise<SurveyPrompt> {
  const query = product ? `?product=${encodeURIComponent(product)}` : '';
  const res = await fetchWithTimeout(`${BASE}/api/v1/survey${query}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<SurveyPrompt>;
}

/** Store the answers. Answering twice keeps the first submission, so a retry is safe. */
export async function submitSurvey(
  version: string,
  product: string | null,
  answers: SurveyAnswers,
  otherText: SurveyOtherText,
): Promise<void> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/survey`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ version, product, answers, other_text: otherText }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
